import React from 'react';
import { AI_WORKFLOW_TYPES } from '@/features/aiWorkflow/constants';
import { MenuItem, Select } from '@mui/material';

const AIEmailTemplateTypeSelect = ({ value, setValue, disabled, ...props }) => {
	const values = [
		{ value: 'None', label: 'None' },
		...Object.entries(AI_WORKFLOW_TYPES).map(([key, title]) => ({
			value: key,
			label: title,
		})),
	];

	return (
		<Select
			disabled={disabled}
			fullWidth
			// {...formik.getFieldProps(formikKey)}
			value={value}
			onChange={(e) => {
				const newValue = e.target.value;
				setValue(!newValue || newValue?.toLowerCase() === 'none' ? '' : newValue);
			}}
			{...props}
		>
			{values.map(({ value, label }) => (
				<MenuItem value={value} key={value}>
					{label}
				</MenuItem>
			))}
		</Select>
	);
};
AIEmailTemplateTypeSelect.displayName = 'AIEmailTemplateTypeSelect';
export default AIEmailTemplateTypeSelect;
